(function() {
    'use strict';

    angular.module('swif.reservations')
    .service('openresaHumanResourcesService', openresaHumanResourcesService)
    .component('openresaResourcesTabset', {
        templateUrl: 'partials/openresa/human_resources_tabset.html',
        controller: OpenresaResourcesTabsetController,
        bindings: {
            onChange: '&?'
        }
    });

    function openresaHumanResourcesService($q, swif) {
        'ngInject';

        const service = {
            countResources: 0,
            onChangeCallback: {},
            currentCollection: 'officers',
            resolveData: resolveData,
            toggleOfficer: toggleOfficer,
            setCurrentTeam: setCurrentTeam,
            setCurrentServiceSupplier: setCurrentServiceSupplier,
        }

        function _onChange(data, type) {
            _.forOwn(service.onChangeCallback, value => {
                value({$value: {data, type}})
            })
        }

        function resolveData(data) {
            data.countResources = 0;

            // Get officers
            let officerFilter = {
                fields: ['id', 'name', 'complete_name', 'team_ids', 'color'],
                limit: 10
            };
            swif.data.addExtraFilter(officerFilter, 'resources', 'type_prod', '=', 'user');
            var officers = swif.collection.createOrUpdate(
                'users_resources',
                'product',
                officerFilter
            ).then(officersCollection => {
                service.officers = officersCollection;
                service.countResources += officersCollection.currentCount;
                if (data) {
                    data.officers = officersCollection;
                    data.countResources += officersCollection.currentCount;
                }
            });

            // Get teams
            let teamFilter = {
                fields: ['id', 'name', 'manager_id', 'user_ids', 'user_names', 'color'],
                limit: 10
            };
            swif.data.addExtraFilter(teamFilter, 'resources', 'type_prod', '=', 'team');
            var teams = swif.collection.createOrUpdate(
                'teams_resources',
                'product',
                teamFilter
            ).then(teamsCollection => {
                service.teams = teamsCollection;
                service.countResources += teamsCollection.currentCount;
                if (data) {
                    data.teams = teamsCollection;
                    data.countResources += teamsCollection.currentCount;
                }
            });

            // Get suppliers
            let suppliersFilter = {
                fields: ['id', 'name', 'manager_id', 'user_ids', 'user_names', 'color'],
                limit: 10
            };
            swif.data.addExtraFilter(suppliersFilter, 'resources', 'type_prod', '=', 'organization');
            var suppliers = swif.collection.createOrUpdate(
                'suppliers_resources',
                'product',
                suppliersFilter
            ).then(suppliersCollection => {
                service.serviceSuppliers = suppliersCollection;
                service.countResources += suppliersCollection.currentCount;
                if (data) {
                    data.serviceSuppliers = suppliersCollection;
                    data.countResources += suppliersCollection.currentCount;
                }
            });

            return $q.all([
                officers,
                teams,
                suppliers
            ]).then(function() {
                return data;
            });
        }

        function toggleOfficer(officer) {
            _onChange(officer, 'officer');
        }

        function setCurrentTeam(team) {
            _onChange(team, 'team');
        }

        function setCurrentServiceSupplier(serviceSupplier) {
            _onChange(serviceSupplier, 'serviceSupplier');
        }

        return service;
    }

    function OpenresaResourcesTabsetController($scope, openresaHumanResourcesService) {
        'ngInject';
        var $ctrl = this;
        const service = openresaHumanResourcesService;

        $scope.officers = service.officers;
        $scope.teams = service.teams;
        $scope.serviceSuppliers = service.serviceSuppliers;

        $scope.toggleOfficer = service.toggleOfficer;
        $scope.setCurrentTeam = service.setCurrentTeam;
        $scope.setCurrentServiceSupplier = service.setCurrentServiceSupplier;

        service.onChangeCallback.directive = $scope.$ctrl.onChange;
        $scope.$on('destroy', function() {
            service.onChangeCallback.directive = undefined;
        });
    }
})();
